import React from 'react';
import { isReskin } from '../config/siteVariant';
import HomePageLegacy from './HomePageLegacy';
import HomePageReskin from './HomePageReskin';

/**
 * HomePage variant selector.
 *
 * Renders the videxa-poc marketing re-skin only when the build was compiled
 * with REACT_APP_SITE_VARIANT=reskin (the dev image). Every other build —
 * including production, where the variable is never set — renders the legacy
 * production home page unchanged. See src/config/siteVariant.js.
 */
const HomePage = (props) =>
  isReskin ? <HomePageReskin {...props} /> : <HomePageLegacy {...props} />;

export default HomePage;
